import React from "react";
import "./DiscussParagraph.scss";

const DiscussParagraph = () => {
  return (
    <h6 className="discuss-paragraph mt-4">
      If you&lsquo;d like to discuss your results or create an action plan for
      improvements, then click on the Dashboard menu option (bottom left) to
      book a consulting hour with one of the TeamLytica experts.
    </h6>
  );
};

export default DiscussParagraph;
